import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { FeatureToggleService } from '@main/shared/feature-toggle';

export const canActivateBrand: CanActivateFn = () => {
    return inject(FeatureToggleService).isEnabled('brand_report') || inject(Router).navigate([`/not-found`]);
};
